import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { saveAs } from 'file-saver';

import { getTraceHistoryExport } from 'api/snapshotApi';
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';

interface Props {
  snapshotId: number;
  begin: Date;
  end: Date;
  disabled: boolean;
}

const ExportHistoryButton = ({ snapshotId, begin, end, disabled }: Props) => {
  const [loading, setLoading] = useState(false);
  const { timezone } = useUserDateTime();

  const handleExportClicked = async () => {
    setLoading(true);
    const fileName = `spectras-trace-history-export_${formatInTimeZone(
      new Date(),
      timezone,
      'yyyy-MM-dd_hh-mm-ss_aa'
    )}.xlsx`;
    const exportedFile = await getTraceHistoryExport(
      snapshotId,
      zonedTimeToUtc(begin, timezone).toISOString(),
      zonedTimeToUtc(end, timezone).toISOString()
    );
    saveAs(exportedFile, fileName);
    setLoading(false);
  };

  return (
    <LoadingButton
      variant='contained'
      color='primary'
      fullWidth
      disabled={disabled}
      loading={loading}
      loadingPosition='start'
      startIcon={<div />}
      onClick={handleExportClicked}
    >
      Export
    </LoadingButton>
  );
};

export default ExportHistoryButton;
